"use client";

import { useState } from "react";
import Image from "next/image";
import EquipmentDialog, { EquipmentItem } from "./EquipmentDialog";

const POPULAR_EQUIPMENT: EquipmentItem[] = [
  {
    id: "pop-1",
    name: "Booty Builder",
    tags: ["Gluteus", "Donja leđa"],
    category: "Sprave",
    image:
      "/img/equipment/BB_Backextension.webp",
    description:
      "Sprava specijalizirana za jačanje gluteusa kroz pokret ekstenzije kuka, uz mogućnost izvođenja i ekstenzije leđa. Podesivo opterećenje i udoban jastuk omogućuju siguran trening za sve razine iskustva.",
  },
  {
    id: "pop-2",
    name: "Nautilus Pullover",
    tags: ["Leđa"],
    category: "Sprave",
    image:
      "/img/equipment/Nautilus-Inspiration-Pull-Over.webp",
    description:
      "Klasična sprava za izolirano jačanje širokog leđnog mišića i stabilizatora ramena kroz pokret povlačenja iznad glave. Prepoznatljiva Nautilus krivulja opterećenja prati prirodnu snagu mišića kroz cijeli raspon pokreta.",
  },
];

export default function PopularEquipmentSection() {
  const [selectedItem, setSelectedItem] = useState<EquipmentItem | null>(null);

  return (
    <>
      <section className="rounded-3xl bg-[#F4F4F5] px-6 py-10 sm:px-8 sm:py-12">
        <h2 className="mb-8 text-3xl font-bold tracking-tight text-[#18181b] sm:text-4xl">
          Najpopularnije sprave
        </h2>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
          {POPULAR_EQUIPMENT.map((item) => (
            <button
              key={item.id}
              onClick={() => setSelectedItem(item)}
              className="group overflow-hidden rounded-2xl border border-[#E4E4E7] bg-white text-left transition-shadow hover:shadow-md"
            >
              {/* Image area */}
              <div className="relative h-72 w-full sm:h-80">
                <Image
                  src={item.image}
                  alt={item.name}
                  fill
                  className="object-contain p-6 transition-transform duration-300 group-hover:scale-105"
                />
              </div>

              {/* Content area */}
              <div className="bg-[#F9FAFB] px-6 py-5">
                <h3 className="mb-3 text-xl font-bold text-[#18181b]">
                  {item.name}
                </h3>
                <div className="flex flex-wrap gap-2">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-[#E4E4E7] bg-white px-3 py-1 text-xs font-medium text-[#52525b]"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </button>
          ))}
        </div>
      </section>

      <EquipmentDialog item={selectedItem} onClose={() => setSelectedItem(null)} />
    </>
  );
}
